export default function replaceComma(str) {
    if(!str){
        return ''
    }
    return str.replace(/","/g, '", "');
}
